export const ProfileFilterStore = {
    state() {
        return {
            "search_name": null,
            "filter_group": null,
        }
    },
    mutations: {
        setFilter(state, payload) {
            if(payload.filter === "name") {
                state.search_name = payload.value;
            }
        },
        resetFilters(state) {
            state.search_name = null;
        },
        setSearchName(state, value) {
            state.search_name = value;
        },
        setFilterGroup(state, value) {
            state.filter_group = value;
        },
    },
    getters: {
        getFilteredUsers(state, getters) {
            return getters['profiles'].filter(function (user) {
                let valid = true;
                if(state.filter_group === null && ["Prestataire"].indexOf(user.group) !== -1) {
                    valid = false;
                }
                if((state.search_name !== null && state.search_name !== "") && (user.fullname.toLowerCase().indexOf(state.search_name?.toLowerCase()) === -1))
                {
                    valid = false;
                }
                if(state.filter_group !== null && user.group !== state.filter_group) {
                    valid = false;
                }
                return valid;
            });
        },
        getFilteredPrestataires(state, getters) {
            return getters['prestataires'].filter(function (profile) {
                let valid = true;
                if(state.search_name !== null && state.search_name !== "" && profile.fullname.toLowerCase().indexOf(state.search_name.toLowerCase()) === -1) {
                    valid = false;
                }
                return valid;
            });
        },
        getFilteredCollaborateurs(state, getters) {
            return getters['collaborateurs'].filter(function (profile) {
                let valid = true;
                if(state.search_name !== null && state.search_name !== "" && profile.fullname.toLowerCase().indexOf(state.search_name.toLowerCase()) === -1) {
                    valid = false;
                }
                return valid;
            });
        },
        getFilteredDemandeurs(state, getters) {
            return getters['demandeurs'].filter(function (profile) {
                let valid = true;
                if(state.search_name !== null && state.search_name !== "" && profile.fullname.toLowerCase().indexOf(state.search_name.toLowerCase()) === -1) {
                    valid = false;
                }
                return valid;
            });
        },
        getFilteredResponsables(state, getters) {
            return getters['responsables_techniques'].filter(function (profile) {
                let valid = true;
                if(state.search_name !== null && state.search_name !== "" && profile.fullname.toLowerCase().indexOf(state.search_name.toLowerCase()) === -1) {
                    valid = false;
                }
                return valid;
            });
        },
        getSearchName(state) {
            return state.search_name;
        },
        getFilterGroup(state) {
            return state.filter_group;
        },
    },
    actions: {},
}